module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a2cb93db49d1d47f17fc38f9d76eaa7a.png";